/* istanbul ignore file */

import { YmapsApi } from '../../../browser/ymaps/ymaps-api';

export const ymaps = new YmapsApi();
